<template>
  <el-card shadow="never" class="card">
    <!-- 顶部区域 -->
    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
      <div style="display: flex; align-items: center;">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="IP">
            <el-input
              v-model="query.ip"
              placeholder="请输入IP"
              clearable
              style="width: 200px;"
              @keyup.enter.native="handleSearch"
            />
          </el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-form>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="openCreateDialog">创建</el-button>
      </div>
    </div>

    <!-- 列表 -->
    <el-table
      v-loading="loading"
      :data="list"
      style="width: 100%;border:1px solid #dfe6ec;"
      header-cell-style="background-color: #f5f7fb; text-align: center;"
      cell-style="text-align: center;"
    >
      <el-table-column prop="ip" label="IP" />

      <!-- 员工名称 -->
      <el-table-column label="员工名称">
        <template slot-scope="scope">
          {{ scope.row.corp_user ? scope.row.corp_user.name : '--' }}
        </template>
      </el-table-column>

      <!-- 企业名称 -->
      <el-table-column label="企业名称">
        <template slot-scope="scope">
          {{ scope.row.corp_user ? scope.row.corp_user.corp_name : '--' }}
        </template>
      </el-table-column>

      <el-table-column label="微信名称">
        <template slot-scope="scope">
          <span v-if="scope.row.wechats && scope.row.wechats.length">
            {{ scope.row.wechats.map(w => w.wechat_name || '--').join(', ') }}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>

      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="success">启用</el-tag>
          <el-tag v-else type="info">禁用</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="created_at" label="创建时间">
        <template slot-scope="scope">
          {{ formatTime(scope.row.created_at) }}
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <span style="color:#165DFF;cursor:pointer" @click="openEditDialog(scope.row)">编辑</span>
          <el-divider direction="vertical" />
          <span style="color:#ff4949;cursor:pointer" @click="handleDelete(scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div style="margin-top: 20px; text-align: right;">
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :page-size="query.page_size"
        :current-page.sync="query.page"
        @current-change="handlePageChange"
      />
    </div>

    <!-- 创建/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" label-width="auto">
        <el-form-item label="IP">
          <el-input v-model="form.ip" placeholder="请输入IP" />
        </el-form-item>

        <!-- 员工选择 -->
        <el-form-item label="员工">
          <div v-if="form.employee">
            <span>{{ form.employee.name }}（{{ form.employee.employee_no }}）</span>
            <el-button type="text" style="color:#ff4949;" @click="removeEmployee">删除</el-button>
            <el-button type="text" @click="openSelectEmployeeDialog">重新选择</el-button>
          </div>
          <div v-else>
            <el-button type="primary" @click="openSelectEmployeeDialog">选择员工</el-button>
          </div>
        </el-form-item>

        <!-- 编辑时才显示状态和微信 -->
        <template v-if="form.id">
          <el-form-item label="状态">
            <el-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
              <el-option label="启用" :value="1" />
              <el-option label="禁用" :value="2" />
            </el-select>
          </el-form-item>

          <el-form-item label="微信名称">
            <div v-if="form.wechats.length">
              <div
                v-for="(wechat, index) in form.wechats"
                :key="index"
                style="display:flex;align-items:center;margin-bottom:5px;"
              >
                <span>{{ wechat.wechat_name }}</span>
                <el-button
                  type="text"
                  icon="el-icon-minus"
                  style="margin-left:5px;color:#ff4949;"
                  @click="removeWechat(index)"
                />
              </div>
            </div>
            <el-button type="primary" icon="el-icon-plus" @click="openSelectWechatDialog">
              新增微信
            </el-button>
          </el-form-item>
        </template>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </div>
    </el-dialog>

    <!-- 子弹窗：选择微信 -->
    <el-dialog title="选择微信" :visible.sync="selectWechatDialogVisible" width="1000px">
      <div style="margin-bottom: 20px; display: flex; gap: 10px;">
        <el-input
          v-model="searchQuery.keywords"
          placeholder="请输入员工名称/外部客户ID"
          clearable
          style="width: 250px;"
          @keyup.enter.native="handleSearchWechat"
        />
        <el-input
          v-model="searchQuery.employee_no"
          placeholder="请输入员工编号"
          clearable
          style="width: 200px;"
          @keyup.enter.native="handleSearchWechat"
        />
        <el-button type="primary" icon="el-icon-search" @click="handleSearchWechat">
          搜索
        </el-button>
      </div>

      <el-table v-loading="loadingWechat" :data="wechatCandidates" style="width: 100%;">
        <el-table-column prop="id" label="ID" />
        <el-table-column prop="employee_no" label="员工编号" width="250" />
        <el-table-column prop="name" label="员工名称" />
        <el-table-column prop="external_user_id" label="外部联系人userid" />
        <el-table-column prop="remark" label="备注" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="addWechatToForm(scope.row)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 20px; text-align: right;">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="wechatTotal"
          :page-size="searchQuery.pageSize"
          :current-page.sync="searchQuery.page"
          @current-change="handleWechatPageChange"
        />
      </div>
    </el-dialog>

    <!-- 子弹窗：选择员工 -->
    <el-dialog title="选择员工" :visible.sync="selectEmployeeDialogVisible" width="800px">
      <!-- 搜索框 -->
      <div style="margin-bottom: 20px; display: flex; gap: 10px;">
        <el-input
          v-model="employeeSearch.keywords"
          placeholder="请输入员工名称/编号"
          clearable
          style="width: 250px;"
          @keyup.enter.native="handleSearchEmployee"
        />
        <el-button type="primary" icon="el-icon-search" @click="handleSearchEmployee">搜索</el-button>
      </div>

      <!-- 列表 -->
      <el-table v-loading="loadingEmployee" :data="employeeCandidates" style="width: 100%;">
        <el-table-column prop="name" label="姓名" />
        <el-table-column prop="corp_name" label="企业" />
        <el-table-column prop="employee_no" label="员工编号" />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="selectEmployee(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div style="margin-top: 20px; text-align: right;">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="employeeTotal"
          :page-size="employeeSearch.pageSize"
          :current-page.sync="employeeSearch.page"
          @current-change="handleEmployeePageChange"
        />
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  windowsClientList,
  windowsClientCreate,
  windowsClientUpdate,
  windowsClientDestroy,
  wechatAccepter
} from '@/api/windowsClientManagement'
import { enterpriseEmployee } from '@/api/enterprisewechatControl'

export default {
  name: 'WindowsClientManagement',
  data() {
    return {
      query: { ip: '', page: 1, page_size: 10 },
      list: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      dialogTitle: '创建',
      form: { id: null, ip: '', employee: null, status: 1, wechats: [] },

      // 微信子弹窗
      selectWechatDialogVisible: false,
      searchQuery: { keywords: '', employee_no: '', page: 1, pageSize: 10 },
      wechatCandidates: [],
      wechatTotal: 0,
      loadingWechat: false,

      // 员工子弹窗
      selectEmployeeDialogVisible: false,
      employeeSearch: { keywords: '', page: 1, pageSize: 10 },
      employeeCandidates: [],
      employeeTotal: 0,
      loadingEmployee: false
    }
  },
  created() { this.fetchList() },
  methods: {
    // ===== 父弹窗逻辑 =====
    async fetchList() {
      this.loading = true
      try {
        const res = await windowsClientList(this.query)
        this.list = res.data.list || []
        this.total = res.data.total || 0
      } finally { this.loading = false }
    },
    formatTime(ts) {
      if (!ts) return '--'
      const date = new Date(ts * 1000)
      const Y = date.getFullYear()
      const M = String(date.getMonth() + 1).padStart(2, '0')
      const D = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const m = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${Y}-${M}-${D} ${h}:${m}:${s}`
    },
    handleSearch() { this.query.page = 1; this.fetchList() },
    handlePageChange(page) { this.query.page = page; this.fetchList() },
    openCreateDialog() {
      this.dialogTitle = '创建'
      this.form = { id: null, ip: '', employee: null, status: 1, wechats: [] }
      this.dialogVisible = true
    },

    openEditDialog(row) {
      this.dialogTitle = '编辑'
      this.form = {
        id: row.id,
        ip: row.ip,
        employee: row.corp_user ? {
          id: row.corp_user.id,
          name: row.corp_user.name,
          corp_name: row.corp_user.corp_name,
          employee_no: row.corp_user.employee_no
        } : null,
        status: row.status,
        wechats: row.wechats ? row.wechats.map(w => ({
          employee_no: w.employee_no,
          external_user_id: w.external_user_id,
          wechat_name: w.wechat_name
        })) : []
      }
      this.dialogVisible = true
    },
    removeWechat(index) { this.form.wechats.splice(index, 1) },
    async submitForm() {
      try {
        if (this.form.id) {
          await windowsClientUpdate({
            ...this.form,
            employee_no: this.form.employee ? this.form.employee.employee_no : ''
          })
        } else {
          await windowsClientCreate({
            ip: this.form.ip,
            employee_no: this.form.employee ? this.form.employee.employee_no : ''
          })
        }
        this.$message.success('操作成功')
        this.dialogVisible = false
        this.fetchList()
      } catch (e) { this.$message.error('操作失败') }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该条记录吗？', '提示', { type: 'warning' })
        await windowsClientDestroy({ id: row.id })
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    },

    // ===== 微信子弹窗逻辑 =====
    openSelectWechatDialog() {
      this.searchQuery = {
        keywords: '',
        employee_no: this.form.employee ? this.form.employee.employee_no : '',
        page: 1,
        pageSize: 10
      }
      this.wechatCandidates = []
      this.selectWechatDialogVisible = true
      this.fetchWechatList()
    },
    async fetchWechatList() {
      this.loadingWechat = true
      try {
        const res = await wechatAccepter(this.searchQuery)
        this.wechatCandidates = res.data.list || []
        this.wechatTotal = res.data.total || 0
      } finally { this.loadingWechat = false }
    },
    handleSearchWechat() { this.searchQuery.page = 1; this.fetchWechatList() },
    handleWechatPageChange(page) { this.searchQuery.page = page; this.fetchWechatList() },
    addWechatToForm(row) {
      this.form.wechats.push({
        employee_no: row.employee_no,
        external_user_id: row.external_user_id,
        wechat_name: row.remark || ''
      })
      this.$message.success(`已添加 ${row.remark || ''}`)
      this.selectWechatDialogVisible = false
    },

    // ===== 员工子弹窗逻辑 =====
    openSelectEmployeeDialog() {
      this.employeeSearch = { keywords: '', page: 1, pageSize: 10 }
      this.employeeCandidates = []
      this.selectEmployeeDialogVisible = true
      this.fetchEmployeeList()
    },
    async fetchEmployeeList() {
      this.loadingEmployee = true
      try {
        const res = await enterpriseEmployee(this.employeeSearch)
        this.employeeCandidates = res.data.list || []
        this.employeeTotal = res.data.total || 0
      } finally { this.loadingEmployee = false }
    },
    handleSearchEmployee() { this.employeeSearch.page = 1; this.fetchEmployeeList() },
    handleEmployeePageChange(page) { this.employeeSearch.page = page; this.fetchEmployeeList() },
    selectEmployee(row) {
      this.form.employee = row
      this.$message.success(`已选择员工：${row.name}`)
      this.selectEmployeeDialogVisible = false
    },
    removeEmployee() { this.form.employee = null }
  }
}
</script>

<style scoped>
.card { margin: 22px; }
</style>
